import { CookieKey } from '@valk-nx/services/cookie-manager/src/lib/cookie-manager.interface';

export interface CookiePreferences {
	'valk-functional-cookie': boolean;
	'valk-analytics-cookie': boolean;
	'valk-marketing-cookie': boolean;
}

export const CookieAction = {
	Selection: 'selection',
	AcceptAll: 'accept-all',
	RejectAll: 'reject-all',
} as const;

export type CookieAction = (typeof CookieAction)[keyof typeof CookieAction];

export const COOKIE_KEYS: readonly CookieKey[] = [
	'valk-functional-cookie',
	'valk-analytics-cookie',
	'valk-marketing-cookie',
] as const;
